// One reducer to rule them all!
import { reducer as apiv3 } from "data/reducers/apiv3";
import { reducer as friends } from "data/reducers/friends";
import { localeReducer as locale } from "data/reducers/locale";
import { modalReducer as modal } from "data/reducers/modal";
import editPage from "features/ride_reports/App/reducers/editPage";
import reportsPage from "features/ride_reports/App/reducers/reportsPage";
import { reducer as rolloutContest } from "features/ride_reports/App/reducers/rolloutContest";
import { reducer as comments } from "lib/api/comments";
import { reducer as currentUser } from "lib/api/currentUser";
import { reducer as events } from "lib/api/events";
import { reducer as favorites } from "lib/api/favorites";
import { reducer as goalParticipants } from "lib/api/goalParticipants";
import { reducer as goals } from "lib/api/goals";
import { reducer as goalsForUser } from "lib/api/goalsForUser";
import { reducer as rideReports } from "lib/api/rideReports";
import { reducer as routes } from "lib/api/routes";
import { reducer as search } from "lib/api/search";
import { reducer as segments } from "lib/api/segments";
import { reducer as sparseRoutes } from "lib/api/sparseRoutes";
import { reducer as sparseTrips } from "lib/api/sparseTrips";
import { reducer as trips } from "lib/api/trips";
import { reducer as usersFollowed } from "lib/api/usersFollowed";
import { combineReducers } from "redux";

export const rootReducer = combineReducers({
  apiv3,
  modal,
  comments,
  currentUser,
  editPage,
  events,
  favorites,
  friends,
  goals,
  goalsForUser,
  goalParticipants,
  reportsPage,
  rideReports,
  rolloutContest,
  routes,
  search,
  segments,
  sparseRoutes,
  sparseTrips,
  trips,
  usersFollowed,
  locale,
});
